/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { IHSRCharacter } from '../../../common/model/graphql-types';
import { HSRCharacterPopover } from './hsr-popover';
import {
  faAnglesUp,
  faArrowDown,
  faArrowUp,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  employee: IHSRCharacter;
  enablePopover?: boolean;
  showLabel?: boolean;
  showTags?: boolean;
  showIcon?: boolean;
  showTierListchange?: boolean;
  showEidolon?: boolean;
  eidolonSpecial?: boolean;
  currentTier?: string;
  tags?: string;
  role?: string;
}

export const HSRCharacterIcon: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showTags,
  showIcon,
  showTierListchange,
  showEidolon,
  eidolonSpecial,
  currentTier,
  tags,
  role
}) => {
  const image = employee.smallImage
    ? getImage(employee.smallImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box hsr"
      popover={<HSRCharacterPopover character={employee} />}
    >
      <Link to={'/star-rail/characters/' + employee.slug}>
        <div
          className={`avatar hsr rarity-${employee.rarity} ${
            showLabel ? showLabel : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showEidolon && (
            <span
              className={`floating-element eidolon ${
                employee.rarity === '4' ? 'rar-4' : 'rar-5'
              } ${
                (employee.slug === 'trailblazer-preservation' ||
                  employee.slug === 'trailblazer-destruction' ||
                  employee.slug === 'trailblazer-harmony' ||
                  employee.slug === 'trailblazer-remembrance') &&
                'trail'
              } `}
            >
              {employee.rarity === '4' ? (
                <>{eidolonSpecial === true ? <>E6</> : <>E0</>}</>
              ) : (
                <>
                  {employee.slug === 'trailblazer-preservation' ||
                  employee.slug === 'trailblazer-destruction' ||
                  employee.slug === 'trailblazer-remembrance' ||
                  employee.slug === 'trailblazer-harmony' ? (
                    <>E6</>
                  ) : (
                    <>E0S0</>
                  )}
                </>
              )}
            </span>
          )}
        </div>
        {showIcon && (
          <span className="floating-element element">
            {employee.element === 'Physical' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_physical_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Fire' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_fire_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Ice' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_ice_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Wind' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_wind_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Lightning' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_lightning_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Quantum' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_quantum_bg.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Imaginary' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_imaginary_bg.png"
                alt={employee.element}
              />
            )}
          </span>
        )}
        {showTierListchange && employee.tierListNew && (
          <span className="floating-element tier-list-hsr new">NEW</span>
        )}
        {/* Watchlist */}
        {showTierListchange && (
          <>
            {(employee.slug === 'acheron' || employee.slug === 'rappa') && (
              <>
                {(currentTier === 'pure' || currentTier === 'pure_special') && (
                  <>
                    <span className="floating-element tier-list-hsr watchlist">
                      <FontAwesomeIcon icon={faEye} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {(employee.slug === 'firefly' ||
              employee.slug === 'topaz' ||
              employee.slug === 'seele') && (
              <>
                {(currentTier === 'apo' || currentTier === 'apo_special') && (
                  <>
                    <span className="floating-element tier-list-hsr watchlist">
                      <FontAwesomeIcon icon={faEye} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {(employee.slug === 'luocha' ||
              employee.slug === 'aventurine' ||
              employee.slug === 'boothill') && (
              <>
                {(currentTier === 'moc' || currentTier === 'moc_special') && (
                  <>
                    <span className="floating-element tier-list-hsr watchlist">
                      <FontAwesomeIcon icon={faEye} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
          </>
        )}
        {/* Tier list changes */}
        {showTierListchange && (
          <>
            {(employee.slug === 'huohuo' ||
              employee.slug === 'trailblazer-remembrance' ||
              employee.slug === 'blade' ||
              employee.slug === 'herta') && (
              <>
                {(currentTier === 'moc' || currentTier === 'moc_special') && (
                  <>
                    <span className="floating-element tier-list-hsr up">
                      <FontAwesomeIcon icon={faArrowUp} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {employee.slug === 'luocha' && (
              <>
                {(currentTier === 'pure' || currentTier === 'pure_special') && (
                  <>
                    <span className="floating-element tier-list-hsr up">
                      <FontAwesomeIcon icon={faArrowUp} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {employee.slug === 'trailblazer-remembrance' && (
              <>
                {(currentTier === 'apo' || currentTier === 'apo_special') && (
                  <>
                    <span className="floating-element tier-list-hsr up">
                      <FontAwesomeIcon icon={faArrowUp} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {employee.slug === 'argenti' && role === 'Specialist' && (
              <>
                {(currentTier === 'moc' || currentTier === 'moc_special') && (
                  <>
                    <span className="floating-element tier-list-hsr up">
                      <FontAwesomeIcon icon={faArrowUp} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
            {(employee.slug === 'kafka' ||
              employee.slug === 'black-swan' ||
              employee.slug === 'firefly' ||
              employee.slug === 'feixiao' ||
              employee.slug === 'ruan-mei' ||
              employee.slug === 'sampo' ||
              employee.slug === 'himeko' ||
              employee.slug === 'march-7th-swordmaster' ||
              employee.slug === 'topaz' ||
              employee.slug === 'gepard' ||
              employee.slug === 'moze' ||
              employee.slug === 'silver-wolf') && (
              <>
                {(currentTier === 'moc' || currentTier === 'moc_special') && (
                  <>
                    <span className="floating-element tier-list-hsr down">
                      <FontAwesomeIcon icon={faArrowDown} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
          </>
        )}
        {showLabel && <span className="emp-name">{employee.name}</span>}
        {tags && (
          <div className="tier-list-tags">
            {tags.split(',').map((tag, idx) => {
              return (
                <span key={idx} className={`single-tag ${tag}`}>
                  {idx === tags.split(',').length - 1 ? (
                    <>{tag}</>
                  ) : (
                    <>{tag}, </>
                  )}
                </span>
              );
            })}
          </div>
        )}
        {showLabel && employee.isNew && showTags && (
          <span className="tag new">New</span>
        )}
      </Link>
    </CustomPopover>
  );
};
